import { Component } from '@angular/core';

@Component({
  selector: 'app-cp-dialog',
  imports: [],
  template: ``,
})
export class CpDialogComponent {}
